import type { GlobalSearchItemDto } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { GlobalSearchResultItem } from '../Results/GlobalSearchResultItem';
import {
  globalSearchModuleHeaderClassName,
  globalSearchModuleHeaderRowClassName,
} from '../GlobalSearch.styles';

interface GlobalSearchPreviousSearchesProps {
  items: GlobalSearchItemDto[];
  onSelect: (item: GlobalSearchItemDto) => void;
}

export const GlobalSearchPreviousSearches = ({
  items,
  onSelect,
}: GlobalSearchPreviousSearchesProps) => {
  const { t } = useTranslation();

  return (
    <div className="py-3">
      <div className={globalSearchModuleHeaderRowClassName}>
        <h3 className={globalSearchModuleHeaderClassName}>
          {t('components.topbar.search.previousSearches')}
        </h3>
      </div>
      {items.length > 0 ? (
        <ul>
          {items.map(item => (
            <li key={`${item.module}-${item.id}`}>
              <GlobalSearchResultItem
                item={item}
                searchTerm=""
                onSelect={onSelect}
              />
            </li>
          ))}
        </ul>
      ) : (
        <p className="global-search-empty-message px-4 py-1">
          {t('components.topbar.search.noPreviousSearches')}
        </p>
      )}
    </div>
  );
};
